module.exports = __webpack_public_path__ + "img/rspca-nt.0058102.png";